// landing page for the portal area
/* eslint-disable */
import React from "react";
import { connect } from 'react-redux';

import PropTypes from "prop-types";
import { Switch, Redirect, Route } from "react-router-dom";
import ReactNotifications from 'react-notifications-component';
import PageNotFound from '../views/Account/PageNotFound.jsx';
import PageUnauthorised from '../views/Account/Unauthorised.jsx';
import { notificationActions } from 'actions';

// core components
import VisitorHeaderLinks from "components/Header/VisitorHeaderLinks.jsx";
import { ContentBox } from "components/SkyFramework/Boxes/ContentBox";
import Footer from "components/Footer/Footer.jsx";
import visitorRoutes from "../routes/visitorRoutes.jsx";
import LoginRequiredRoute from "layouts/_shared/LoginRequiredRoute.jsx";

import ErrorBoundary from "components/SkyFramework/Helpers/ErrorBoundary";

//import logo
import gisLogo from "../assets/img/GIS_logotype_reversed.svg";
import phrasebookLoad from "../i18n";

const phrasebook = phrasebookLoad()

const switchRoutes = (
  // switching routes of from portal routes
  <Switch>
    {
      visitorRoutes.map((prop, key) => {
        if (prop.redirect)
          return <Redirect from={prop.path} to={prop.to} key={key} />
        return <Route path={prop.path} component={prop.component} key={key} />;
      })
    }
    {/* <LoginRequiredRoute path="/portal/404" component={PageNotFound} />
    <LoginRequiredRoute path="/portal/unauthorised" component={PageUnauthorised} />
    <Redirect to="/portal/404" /> */}
  </Switch>
);

class VisitorArea extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // loggedUser: props.authUser,
      notifications: undefined
    }
  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps) {

  }

  render() {
    const { classes, ...rest } = this.props;
    return (<div className="wrapper">
      {/* Here we can load different header depend of login */}
      <div className="header">
        <VisitorHeaderLinks
          image={gisLogo}
        />
      </div>
      {/* <Header routes={portalRoutes}

        {...rest} /> */}
      <ErrorBoundary>
        <div className="content flex-column">
          <div className="container-sm">
            {switchRoutes}
          </div>
        </div>
      </ErrorBoundary>
      <ReactNotifications />
      <Footer />
    </div >
    );
  }
}

function mapStateToProps(state) {
  const { georesource } = state;
  return {
    dialcodes: georesource.dialcodes
  };
}

const dashboard = connect(mapStateToProps)(VisitorArea);


export default (dashboard);
